import React, { Component } from 'react'
import { observer } from 'mobx-react'
import * as R from 'ramda'
import i18n from 'i18next'

import Modal from '../../../UniformComponents/Modal'
import Button from '../../../UniformComponents/Button'
import ChartCreation from '../../ChartCreation/ChartCreation'

@observer
export default class AddChartModal extends Component {
    setSaveFunction = (fn) => {
        this.chartSaveFunction = fn
    }

    save = async () => {
        await this.chartSaveFunction?.()
    }

    close = () => {
        const { store } = this.props
        store.showChartCreation = false
        store.chartCreationPageId = null
    }

    render() {
        const { props } = this
        const { store } = props
        return (

            <Modal
                show={store.showChartCreation}
                onClose={this.close}
                style={{ width: 850 }}
            >
                <div id="add-chart-modal">
                    <div className="uc-modal__header">
                        <h2>{i18n.t('chartCreation.title')}</h2>
                    </div>
                    <ChartCreation store={store} setSaveFunction={this.setSaveFunction} />
                    <div className="uc-modal__button-panel">
                        <Button
                            onClick={this.close}
                            cssClass="error"
                            label={i18n.t('discard')}
                        />
                        <Button
                            onClick={this.save}
                            cssClass="primary"
                            label={i18n.t('save')}
                        />
                    </div>
                </div>
            </Modal>
        )
    }
}
